import React, { useContext, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import classNames from 'classnames'
import s from './ItineraryResultMainContent.less'
import { AdDesktopRectangleItineraryResult } from '../advertising/InlineDesktopAdBanner'
import RouteList from './RouteList'
import ModeSwitcher from './ModeSwitcher'
import { ScrollContext } from '../genericComponents/ResponsiveScrollableWrapper/ResponsiveScrollableWrapper'
import Footer from '../footer/Footer'
import PushPoisOnRoute from './poisonroute/PushPoisOnRoute'
import { OpeSpeDriverBanner } from '../advertising/OpeSpeBanner'
import NPSSurvey from '../survey/NPSSurvey'
import ItineraryResultAdVideo from './display/ItineraryResultAdVideo'
import { selectItineraryError } from '../../store/itinerary/itinerary.selectors'
import AutoPromoGE from '../autopromo/AutoPromoGE'
import ItineraryAwarenessMessage from './ItineraryAwarenessMessage'
import ItineraryTextError from './ItineraryTextError'
import ItineraryResultFaqLink from './ItineraryResultFaqLink'
import ItineraryBonjourRedirection from './ItineraryBonjourRedirection'

const ItineraryResultMainContent = () => {
  const { scrollTo } = useContext(ScrollContext)
  const currentElRef = useRef()
  const error = useSelector(selectItineraryError)

  useEffect(() => {
    setTimeout(() => {
      scrollTo(0, true)
    }, 10)
  }, [])

  return (
    <div ref={currentElRef}>
      <div className={classNames(s.ItineraryResultMainContent)}>
        <ModeSwitcher />
        <ItineraryTextError error={error} />
        {!error && <RouteList />}
        <OpeSpeDriverBanner />
        {!error && <ItineraryBonjourRedirection />}
        {!error && <ItineraryResultFaqLink />}
        <ItineraryResultAdVideo />
        <AdDesktopRectangleItineraryResult />
        <PushPoisOnRoute />
        <ItineraryAwarenessMessage />
      </div>
      <AutoPromoGE />
      <Footer />
      <NPSSurvey />
    </div>
  )
}

export default ItineraryResultMainContent
